export default __webpack_public_path__ + "static/media/kaus-persona-2.a4ff43b6.jpg";